// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.input-field {
  display: flex;
  flex-direction: column;
  position: relative;
  margin-bottom: 24px;
}
.input-field.no-margin {
  margin-bottom: 0;
}
.input-field__label {
  font-size: 16px;
  font-weight: normal;
  margin-bottom: 8px;
}
.input-field__input {
  height: 52px;
  padding: 24px;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}
.input-field__input:focus {
  outline-color: #0abf53;
}
.input-field__icon {
  position: absolute;
  right: 16px;
  font-size: 24px;
  height: 24px;
  bottom: 14px;
  line-height: 24px;
  color: #0abf53;
}
.input-field .inputWithButton {
  position: relative;
}
.input-field .inputWithButton input {
  width: 100%;
}
.input-field .inputWithButton button {
  position: absolute;
  right: 0;
  top: 5px;
  margin-right: 10px;
}
.input-field p {
  border: 1px solid red;
  margin-top: 5px;
  padding: 5px;
  font-size: 12px;
  color: red;
  white-space: pre-line;
}
.input-field input:invalid {
  border-color: red;
}
.input-field input,
.input-field input:valid {
  border-color: none;
}`, "",{"version":3,"sources":["webpack://./src/components/InputField/InputField.scss","webpack://./src/utils/scss/_variables.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AADF;AAGE;EACE,gBAAA;AADJ;AAGE;EACE,eAAA;EACA,mBAAA;EACA,kBAAA;AADJ;AAGE;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;AADJ;AAEI;EACE,sBCxBU;ADwBhB;AAGE;EACE,kBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;EACA,cClCY;ADiChB;AAIE;EACE,kBAAA;AAFJ;AAKE;EACE,WAAA;AAHJ;AAME;EACE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,kBAAA;AAJJ;AAME;EACE,qBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,qBAAA;AAJJ;AAME;EACE,iBAAA;AAJJ;AAME;;EAEE,kBAAA;AAJJ","sourcesContent":["@import \"./../../utils/scss/variables\";\n\n.input-field {\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  margin-bottom: 24px;\n\n  &.no-margin {\n    margin-bottom: 0;\n  }\n  &__label {\n    font-size: 16px;\n    font-weight: normal;\n    margin-bottom: 8px;\n  }\n  &__input {\n    height: 52px;\n    padding: 24px;\n    box-sizing: border-box;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    font-size: 16px;\n    &:focus {\n      outline-color: $primary-color;\n    }\n  }\n  &__icon {\n    position: absolute;\n    right: 16px;\n    font-size: 24px;\n    height: 24px;\n    bottom: 14px;\n    line-height: 24px;\n    color: $primary-color;\n  }\n\n  .inputWithButton {\n    position: relative;\n  }\n\n  .inputWithButton input {\n    width: 100%;\n  }\n\n  .inputWithButton button {\n    position: absolute;\n    right: 0;\n    top: 5px;\n    margin-right: 10px;\n  }\n  p {\n    border: 1px solid red;\n    margin-top: 5px;\n    padding: 5px;\n    font-size: 12px;\n    color: red;\n    white-space: pre-line;\n  }\n  input:invalid {\n    border-color: red;\n  }\n  input,\n  input:valid {\n    border-color: none;\n  }\n}\n","$primary-color: #0abf53;\n\n// Screen size variables\n$screen-xxs-max: 370px; // Tiny phones\n$screen-xs-max: 425px; // Tiny phones\n$screen-sm-max: 576px; // Small tablets and large smartphones (landscape view)\n$screen-md-max: 767px; // Small tablets (portrait view)\n$screen-lg-max: 1024px; // Tablets and small desktops\n$screen-upper-lg-max: 1120px; // Tablets and small desktops\n$screen-xl-max: 1440px; // Large tablets and desktops\n\n// z-index\n$z-indexes: (\"login\", \"loginFooter\", \"loginOverlay\");\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
